// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jut__ColumnAdapter__textRight{text-align:right}.jut__ColumnAdapter__textLeft{text-align:left}.jut__ColumnAdapter__textCenter{text-align:center}", "",{"version":3,"sources":["webpack://./../../../../../src/dataview/DataViewAdapters/columns/useMappedProps/ColumnAdapter.module.scss","webpack://./../../platform/@jutro/legacy/dataview/DataViewAdapters/columns/useMappedProps/ColumnAdapter.module.css"],"names":[],"mappings":"AAAA,+BACE,gBCCF,CDEA,8BACE,eCCF,CDEA,gCACE,iBCCF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textRight": "jut__ColumnAdapter__textRight",
	"textLeft": "jut__ColumnAdapter__textLeft",
	"textCenter": "jut__ColumnAdapter__textCenter"
};
export default ___CSS_LOADER_EXPORT___;
